// import React from "react";
import about from "../assets/Aboutus.png"
import abt from "../assets/abt.png"
// import financialgrowth from "../assets/business-plan.png"
// import strat from "../assets/strategy-development.png"
// import safe from "../assets/shield.png"
import { Link } from "react-router-dom";

const AboutUs = () => {
  return (
    <>
      <div className="py-5"></div>
      <section className="container p-4">
        <div className="row align-items-center">
          <div className="col-md-6">
            <img
              src={about}
              alt="Financial Growth"
              className="img-fluid"
            />
          </div>
          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <div className="p-4">
              <p className="heading">
                Welcome to <span style={{ color: "#76ABAE" }}>Aura Financials</span>
              </p>
              <p className="content">
                At <strong>Aura Financials</strong>, we empower individuals and businesses with
                smart financial solutions. Our mission is to provide expert insights, tools,
                and resources that help you navigate the complexities of finance with
                confidence. Whether you're looking for investment strategies, financial
                planning, or wealth management, we are here to guide you every step of the
                way.
              </p>
              <Link to="/services" className="btn btn-light fw-semibold rounded-pill px-4 my-2">
              Explore Our Services
              </Link>
            
            </div>
          </div>
        </div>
      </section>
      <div className="py-5"></div>
      <div className="py-5"></div>

      <section>
        <div className="container">
          <div className="row">
            <div className="text-center title">
              Our <span style={{ color: "#76ABAE" }}>Story</span>
            </div>
            <div className="py-4"></div>
            <p className="text-center">
              Founded with a vision to make financial literacy accessible to everyone, Aura
              Financials has grown into a trusted name in the industry. From personalized
              wealth management to innovative financial tools, we help you take control of
              your financial future with clarity and confidence.
            </p>
            <div className="d-flex justify-content-center">
              <img
                src={abt}
                alt="Financial Strategy"
                className="img-fluid"
                style={{ height: "100%", width: "400px" }}
              />
            </div>
          </div>
        </div>
      </section>
      <div className="py-5"></div>
      <div className="py-5"></div>

      <section>
        <div className="container">
          <p className="title text-center">
            What We <span style={{ color: "#76ABAE" }}>Stand For</span>
          </p>
          <div className="py-5"></div>
          
          <div className="row text-center">
            <div className="col-md-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="#76ABAE"  class="bi bi-graph-up-arrow" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M0 0h1v15h15v1H0zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5"/>
          </svg>
              <p className="title fs-5 pt-4">Financial Growth</p>
              <p className="content">Helping you achieve long-term wealth</p>
            </div>
            <div className="col-md-4">
               <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="#76ABAE"  class="bi bi-file-earmark-bar-graph" viewBox="0 0 16 16">
                  <path d="M10 13.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm-2.5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5zm-3 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5z"/>
                  <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                </svg>
              <p className="title fs-5 pt-4">Investment Strategies</p>
              <p className="content">Maximizing returns with smart planning</p>
            </div>
            <div className="col-md-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="#76ABAE" class="bi bi-shield-check" viewBox="0 0 16 16">
              <path d="M5.338 1.59a61 61 0 0 0-2.837.856.48.48 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.7 10.7 0 0 0 2.287 2.233c.346.244.652.42.893.533q.18.085.293.118a1 1 0 0 0 .101.025 1 1 0 0 0 .1-.025q.114-.034.294-.118c.24-.113.547-.29.893-.533a10.7 10.7 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.8 11.8 0 0 1-2.517 2.453 7 7 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7 7 0 0 1-1.048-.625 11.8 11.8 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 63 63 0 0 1 5.072.56"/>
              <path d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0"/>
            </svg>
                  <p className="title fs-5 pt-4">Financial Security</p>
              <p className="content">Protecting your assets for the future</p>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-center pt-5">
          <Link to="/blog"><button className="btn btn-light rounded-pill px-4 ms-2">Get Started</button></Link>
          </div>
        </div>
      </section>
      <div className="py-5"></div>
    </>
  );
};

export default AboutUs;
